//import liraries


import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize, } from "rn-responsive-styles";




// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      flexDirection: "row",
      width: 1003,
      height: 427.7,
      marginTop: 30,
      marginLeft: 10,
    },
    container: {
      width: 708,
      height: 427.7,
      marginLeft: 15,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginRight: 20,
      marginTop: 0,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,

      elevation: 5,
    },
    spinner: {
      marginTop: -25,
      transform: [
        { scaleX: 1 },
        { scaleY: 1 },
      ],
    },
    containerLoader: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.5)',
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: 99
    },
    validateButtonViewStyle: {
      width: 123.5,
      height: 36,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 5
    },
    tabBannerStyle: {
      display: "none"
    },
    mobileBannerStyle: {
      display: "none"
    },
    backIconViewStyle: {
      flexDirection: "row",
      margin: 20,
    },
    backIconStyle: {
      width: 19,
      height: 19,
      resizeMode: "center",
    },
    viewStyle: {
      paddingLeft: "8%",
      height: "55%",
      width: "100%",
      paddingTop: 20,
      flexDirection: "row",
      justifyContent: "space-between"
    },
    fuelPaymentTextStyle: {
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
    },
    fuelStatusTextStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "300",
      fontStyle: "normal",
      lineHeight: 22,
      letterSpacing: 0.42,
      textAlign: "left",
      color: "#757575",
    },
    toggleContainerStyle: {

      width: 107,
      height: 28,
      borderRadius: 14,
      justifyContent: "center",
      marginTop: 10,
    },
    toggleViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    switchViewStyle: {
      width: 18.8,
      height: 18.8,
      borderRadius: 9.4,
      backgroundColor: "#ffffff",
      marginHorizontal: 3,
    },
    fuelIconStyle: {
      width: 184,
      height: 175
    },
    activeTextStyle: {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.44,
      textAlign: "left",
    },
    secondViewStyle: {
      height: "45%",
      backgroundColor: "#f2f4f5",
      width: "100%",
      borderBottomRightRadius: 14,
      borderBottomLeftRadius: 14,

    },
    bannerStyle: {
      width: 361,
      height: 437.7
    },
    bannerMobileStyle: {
      display: "none"
    },
    bannerTabStyle: {
      display: "none"
    },
    recentTransTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
      marginLeft: 25,
    },
    tableContainerStyle: {
      width: "90%",
      height: 135.8,
      borderRadius: 8,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#c2c2c2",
      marginTop: 10,
      alignSelf: "center",
    },
    headingViewStyle: {
      flexDirection: "row",
      alignItems: "flex-start",
      //flex:1,
      paddingLeft: 20,
      height: 32,
      backgroundColor: "#ffffff",
      borderTopRightRadius: 10,
      borderTopLeftRadius: 10,
    },
    submitBtnWidget:{
      width: 123.5,
      height: 36,
      alignSelf: "center",
      marginTop: 20,
    },
    spinnerBox:{
      width: 323,
      height: 192,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27
      },
      shadowRadius: 34,
      shadowOpacity: 1,
      alignItems: "center",
      justifyContent: "center"
    },
    btnWrapper:{
      alignItems: "center",
      marginTop: 20,
      flexDirection: "row",
      justifyContent: "center"
    },
    withoutPanBtnWidget:{
      width: 153.5,
      height: 36,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 5
    },
    headingTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 26,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      flex: 1,
    },
    dataViewStyle: {
      flexDirection: "row",
      alignItems: "flex-start",
      paddingLeft: 20,
      height: 32,
    },
    dataTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 26,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      flex: 1,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    creditOverlay: {
      width: "70%",
      height: "50%",
      alignItems: "center",
      backgroundColor: "white",
      borderRadius: 15,
    },
    loaderBg: {
      backgroundColor: "white",
      width: "70%",
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    overlayContentViewStyle: {
      width: 348.1,
      height: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    enterOtpTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 21,
      letterSpacing: 0.64,
      textAlign: "center",
      color: "#66625f",
      paddingTop: 20,
    },
    otpDescTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 10,

      marginHorizontal: 30,
    },
    otpInputViewStyle: {
      width: 250.4,
      height: 38,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 1.5,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 3.6,
      textAlign: "left",
      color: "#66625f",
      borderRadius: 5,
      marginTop: 20,
      alignSelf: "center",
      paddingLeft: 10,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
      marginTop: 5,
    },
    timerTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bd2d37",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainContainer: {
        flexDirection: "row",
        width: 800,
      },
      container: {
        width: 800,
        borderRadius: 15,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        flexDirection: "column",
        width: "95%",
        height: 649,
        marginTop: 30,
        marginLeft: 10,
      },
      container: {
        height: 649,
        width: "100%",
        borderRadius: 15,
      },
      bannerStyle: {
        display: "none"
      },
      bannerTabStyle: {
        display: "flex",
        width: "100%",
        height: 163,
      },
      tabBannerStyle: {
        display: "flex"
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: 528,
        height: 649,
        borderRadius: 15,
      },
      contentViewStyle: {
        flexDirection: "column",
        justifyContent: "space-around",
        marginHorizontal: 30,
      },
      bannerStyle: {
        display: "none"
      },
      mobileBannerStyle: {
        display: "flex"
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: "95%",
        height: 638,
        borderRadius: 20,
      },

      contentViewStyle: {
        flexDirection: "column",
        justifyContent: "space-around",
        marginHorizontal: 30,
      },
      bannerStyle: {
        display: "none"
      },
      overlayContentViewStyle: {
        width: "95%"
      },
      validateButtonViewStyle: {
        width: 93.5,
      },
      bannerMobileStyle: {
        display: "flex",
        height: 116,
        width: "100%"
      },
      mainContainer: {
        flexDirection: "column",
        width: "100%",
        marginLeft: 0
      },
      viewStyle: {
        justifyContent: "flex-start",
      },
      fuelIconStyle: {
        width: 70,
        height: 135,
      },
      mobileBannerStyle: {
        display: "flex"
      },
    },
  }
);

//make this component available to the app
export default useStyles;
